module.exports = __webpack_public_path__ + "img/cp-example.134dd1f2.png";